import { Controller } from "@hotwired/stimulus"

/**
 * Copies the text content of a source element to the clipboard.
 *
 * Used by the one-time revealed-credentials panel so an admin can copy
 * the full username/password list in a single click to hand off to a
 * client coordinator. The copied text lives only in the DOM of the
 * current (no-store) response; nothing is persisted.
 *
 * @example
 *   <div data-controller="clipboard">
 *     <pre data-clipboard-target="source">...</pre>
 *     <button data-action="clipboard#copy"
 *             data-clipboard-copied-text="Copied!">Copy</button>
 *   </div>
 */
export default class extends Controller {
  static targets = ["source"]

  copy(event) {
    const button = event.currentTarget
    const text = this.sourceTarget.innerText

    navigator.clipboard.writeText(text).then(() => {
      const original = button.innerText
      const copied = button.dataset.clipboardCopiedText || "Copied"
      button.innerText = copied
      setTimeout(() => { button.innerText = original }, 2000)
    })
  }
}
